import type { ReactNode } from 'react'
import { Paywall } from './Paywall'
import { usePremiumAccess } from '../api/usePremiumAccess'

interface PremiumGateProps {
  children: ReactNode
}

export function PremiumGate({ children }: PremiumGateProps) {
  const { refresh, shouldBlockApp } = usePremiumAccess()

  return (
    <>
      {children}
      <Paywall
        isOpen={shouldBlockApp}
        onPurchased={async () => {
          await refresh()
        }}
      />
    </>
  )
}
